import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../zodios/client";

export const useCampaignStatsHourly = (
  params: Parameters<typeof apiClient.getCampaignStatsHourly>[0]["queries"],
  options: { enabled?: boolean } = {},
) =>
  useQuery({
    queryKey: [
      {
        endpoint: "/api/data_report_v2/campaignstatshourly/stats/",
        params,
      },
    ],
    queryFn: async () => await apiClient.getCampaignStatsHourly({ queries: params }),
    ...options,
  });
